import { createContext, use } from 'react'

import {
  CommandActionArgs,
  CommandContextArgs,
} from '~/components/command-menu/types'

export const useCommandArgs = () => {
  const commandArgs = use(CommandArgsContext)

  if (!commandArgs) {
    throw new Error('useCommandArgs must be used within CommandMenuProvider')
  }

  return commandArgs
}

export const CommandArgsContext = createContext<{
  contextArgs: CommandContextArgs
  actionArgs: CommandActionArgs
} | null>(null)
